
import React from "react";
import { TableRow, TableHead } from "@/components/ui/table";
import { SortField } from "@/hooks/admin/users/types";

interface UserTableHeaderProps {
  sortField?: SortField;
  sortOrder?: 'asc' | 'desc';
  onSort?: (field: SortField) => void;
}

const UserTableHeader = ({ sortField, sortOrder, onSort }: UserTableHeaderProps) => {
  const getSortIcon = (field: SortField) => {
    if (sortField !== field) return null;
    return sortOrder === 'asc' ? '↑' : '↓';
  };

  return (
    <TableRow>
      <TableHead 
        className="cursor-pointer"
        onClick={() => onSort && onSort('email')}
      >
        Email {getSortIcon('email')}
      </TableHead>
      <TableHead 
        className="cursor-pointer"
        onClick={() => onSort && onSort('first_name')}
      >
        Name {getSortIcon('first_name')}
      </TableHead>
      <TableHead 
        className="cursor-pointer"
        onClick={() => onSort && onSort('role')}
      >
        Role {getSortIcon('role')}
      </TableHead>
      <TableHead>Provider</TableHead>
      <TableHead 
        className="cursor-pointer"
        onClick={() => onSort && onSort('created_at')}
      >
        Created At {getSortIcon('created_at')}
      </TableHead>
      <TableHead className="text-right">Actions</TableHead>
    </TableRow>
  );
};

export default UserTableHeader;
